import { GET_ACTIVITY_FOLLOW_UP, GET_ACTIVITY_FOLLOW_UP_FAIL, GET_ACTIVITY_FOLLOW_UP_SUCCESS, GET_ACTIVITY_PROJECT_FOLLOW_UP, GET_ACTIVITY_PROJECT_FOLLOW_UP_FAIL, GET_ACTIVITY_PROJECT_FOLLOW_UP_SUCCESS, GET_CONTACT_ACTIVITY_FOLLOW_UP, GET_CONTACT_ACTIVITY_FOLLOW_UP_FAIL, GET_CONTACT_ACTIVITY_FOLLOW_UP_SUCCESS, GET_PROJECT_LEAD_ALL_ACT, GET_PROJECT_LEAD_ALL_ACT_FAIL, GET_PROJECT_LEAD_ALL_ACT_SUCCESS, GET_PROJECT_LEAD_CALLLOG, GET_PROJECT_LEAD_CALLLOG_FAIL, GET_PROJECT_LEAD_CALLLOG_SUCCESS, GET_PROJECT_LEAD_EMAILLOG, GET_PROJECT_LEAD_EMAILLOG_FAIL, GET_PROJECT_LEAD_EMAILLOG_SUCCESS, GET_PROJECT_LEAD_FOLLOW, GET_PROJECT_LEAD_FOLLOW_FAIL, GET_PROJECT_LEAD_FOLLOW_SUCCESS, GET_PROJECT_LEAD_NOTE, GET_PROJECT_LEAD_NOTE_FAIL, GET_PROJECT_LEAD_NOTE_SUCCESS } from "./actionTypes"

const initialState = {

  boxLoading: true

}

const projectleads = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROJECT_LEAD_ALL_ACT:
      return { ...state, boxLoading: true }
    case GET_PROJECT_LEAD_ALL_ACT_SUCCESS:
      return { ...state, activities: action.payload, boxLoading: false }
    case GET_PROJECT_LEAD_ALL_ACT_FAIL:
      return { ...state, error: action.payload, boxLoading: false }

    case GET_PROJECT_LEAD_NOTE:
      return { ...state, boxLoading: true }
    case GET_PROJECT_LEAD_NOTE_SUCCESS:
      return { ...state, notes: action.payload, boxLoading: false }
    case GET_PROJECT_LEAD_NOTE_FAIL:
      return { ...state, error: action.payload, boxLoading: false }
    case GET_PROJECT_LEAD_NOTE:
      return { ...state, boxLoading: true }
    case GET_PROJECT_LEAD_NOTE_SUCCESS:
      return { ...state, notes: action.payload, boxLoading: false }
    case GET_PROJECT_LEAD_NOTE_FAIL:
      return { ...state, error: action.payload, boxLoading: false }
    case GET_PROJECT_LEAD_CALLLOG:
      return { ...state, boxLoading: true }
    case GET_PROJECT_LEAD_CALLLOG_SUCCESS:
      return { ...state, calllogs: action.payload, boxLoading: false }
    case GET_PROJECT_LEAD_CALLLOG_FAIL:
      return { ...state, error: action.payload, boxLoading: false }
    case GET_PROJECT_LEAD_EMAILLOG:
      return { ...state, boxLoading: true }
    case GET_PROJECT_LEAD_EMAILLOG_SUCCESS:
      return { ...state, emaillogs: action.payload, boxLoading: false }
    case GET_PROJECT_LEAD_EMAILLOG_FAIL:
      return { ...state, error: action.payload, boxLoading: false }
    case GET_ACTIVITY_FOLLOW_UP:
      return { ...state, boxLoading: true }
    case GET_ACTIVITY_FOLLOW_UP_SUCCESS:
      return { ...state, leadFollows: action.payload, boxLoading: false }
    case GET_ACTIVITY_FOLLOW_UP_FAIL:
      return { ...state, error: action.payload, boxLoading: false }
    case GET_ACTIVITY_PROJECT_FOLLOW_UP:
      return { ...state, boxLoading: true }
    case GET_ACTIVITY_PROJECT_FOLLOW_UP_SUCCESS:
      return { ...state, leadFollows: action.payload, boxLoading: false }
    case GET_ACTIVITY_PROJECT_FOLLOW_UP_FAIL:
      return { ...state, error: action.payload, boxLoading: false }
    case GET_CONTACT_ACTIVITY_FOLLOW_UP:
      return { ...state, boxLoading: true }
    case GET_CONTACT_ACTIVITY_FOLLOW_UP_SUCCESS:
      return { ...state, leadFollows: action.payload, boxLoading: false }
    case GET_CONTACT_ACTIVITY_FOLLOW_UP_FAIL:
      return { ...state, error: action.payload, boxLoading: false }
    default:
      state = { ...state }
      break
  }
  return state
}

export default projectleads
